import {gql} from "@apollo/client/core";
import {OrderHistoryViewFragment} from "../fragments/order-history/order-history-view-fragment";

export const GetDateRanges = gql`
    query GetDateRanges {
        getDateRanges {
            display
            endDate
            startDate
            tag
        }
    }
`;

export const GetOrderViews = gql`
    query GetOrderViews($startDate: String, $endDate: String) {
        getOrderViews(startDate: $startDate, endDate: $endDate) {
            ...OrderHistoryViewFragment
        }
    }
    ${OrderHistoryViewFragment}
`;

export const GetOrderView = gql`
    query GetOrderView($orderId: Long) {
        getOrderView(orderId: $orderId) {
            ...OrderHistoryViewFragment
        }
    }
    ${OrderHistoryViewFragment}
`;

export const GetPackslipPdf = gql`
    query GetPackslipPdf($warehouseId: String, $packslipId: Int, $orderId: Int) {
        getPackslipPdf(warehouseId: $warehouseId, packslipId: $packslipId, orderId: $orderId)
    }
`;
